﻿import * as React from 'react';
import { NavLink } from "react-router-dom";

export default function SafetyLauncher() {

    return (
        <div id="assets-launcher-container">
            <h1 className="main-title">SAFETY</h1>

            <div className="card-container">
                <NavLink className="pw-card-link" to="/hazards-maintenance">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon pw-red">emergency_home</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title pw-red">HAZARDS</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/precautionary-statements-maintenance">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon pw-red">emergency_home</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title pw-red">Prec State</div>
                        </div>
                    </div>
                </NavLink>
                
            </div>
        </div>
    );
}